export const getCardArrangement = (
  handlers: Record<'default', () => unknown[]>,
) => {
  return handlers['default']()
}
